module.exports = __webpack_public_path__ + "img/default_poster.c909b8ae.jpg";